import type { CSSProperties } from 'react';

// The shared Tooltip lifts antd's 250px cap, so longer copy passes this to wrap instead of
// running off the page.
export const WRAPPING_TOOLTIP_STYLE: CSSProperties = { maxWidth: 250, textAlign: 'center' };
